import { getDesignToken } from 'styles/constants';
import { textVariants } from 'styles/constants/fonts';

import {
  createNativeBaseThemeComponents,
  createNativeBaseThemeTokens,
} from '../../utils/native-base';
import { ComponentVariants, ForcedNativeBaseThemeType } from '../../utils/native-base/types';
import { SharedVariants, sharedNativeBaseThemeComponents } from '../shared/native-base-theme';

import { nativeBasePrimitives } from './native-base-primitives';

const {
  breakpoints,
  space,
  sizes,
  shadows,
  opacity,
  letterSpacings,
  lineHeights,
  fontConfig,
  fontWeights,
  fontSizes,
  borderWidths,
  fonts,
  radii,
  colors,
} = nativeBasePrimitives;

const tokens = createNativeBaseThemeTokens({
  breakpoints,
  space,
  sizes,
  shadows,
  opacity,
  letterSpacings,
  lineHeights,
  fontConfig,
  fontWeights,
  fontSizes,
  borderWidths,
  fonts,
  radii,
  colors,
});

type Variants = SharedVariants &
  ComponentVariants<{
    BrandLogo: {
      variants: {
        BkLogoPrimary: {};
        BkLogoRoyalPerks: {};
        BkLogoRoyalPerksFR: {};
        BkLogoSecondary: {};
        primary: {};
      };
    };
    IconButton: {
      variants: {
        ghost: {};
        input: {};
        outline: {};
        solid: {};
      };
    };
    Text: {
      variants: {
        copyOne: {};
        copyTwo: {};
        formUtility: {};
        headerFour: {};
        headerOne: {};
        headerThree: {};
        headerTwo: {};
        hero: {};
      };
    };
  }>;

const components = createNativeBaseThemeComponents(sharedNativeBaseThemeComponents, {
  Button: {
    defaultProps: {
      _text: {
        fontWeight: 400,
      },
    },
  },
  BrandLogo: {
    variants: {
      primary: {
        // @ts-ignore variant is not defined in a variant.
        variant: 'BkLogoPrimary',
      },
      BkLogoPrimary: {
        // @ts-ignore 56 not in primitives.
        height: '56px',
      },
      BkLogoRoyalPerks: {
        height: '16',
      },
      BkLogoRoyalPerksFR: {
        height: '16',
      },
      BkLogoSecondary: {
        height: '4',
      },
    },
  },
  Icon: {
    variants: {
      rewards: { name: 'custom:BkCrown' },
    },
  },
  Text: {
    baseStyle: {
      // @ts-ignore NB is not typing this correctly
      color: getDesignToken('text-default'),
      fontWeight: 400,
    },
    // @ts-ignore NB is not typing accessibilityLevel correctly
    variants: textVariants,
  },
  Checkbox: {
    baseStyle: {
      _hover: {
        _interactionBox: {
          bg: 'blackOpacity.5',
        },
        borderColor: getDesignToken('border-color-hover'),
      },
    },
  },
});

export const nativeBaseTheme = ({
  ...tokens,
  config: { initialColorMode: 'light' },
  components,
} as unknown) as ForcedNativeBaseThemeType<typeof tokens, Variants>;
